import { useEffect, useState } from 'react';
import type { ServerCapabilities } from '@app/shared';
import { api } from './api.ts';

let pending: Promise<ServerCapabilities> | null = null;

/** What the server can really do (email delivery, push, Google). Fetched once per page load. */
export function fetchCapabilities(): Promise<ServerCapabilities> {
  pending ??= api<ServerCapabilities>('/api/capabilities', { allowUnauthorized: true }).catch((err) => {
    pending = null;
    throw err;
  });
  return pending;
}

export function useCapabilities(): ServerCapabilities | null {
  const [caps, setCaps] = useState<ServerCapabilities | null>(null);
  useEffect(() => {
    let alive = true;
    fetchCapabilities()
      .then((c) => alive && setCaps(c))
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);
  return caps;
}
